//import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { Provider } from './components/ui/provider.tsx'
import { ColorPaletteProvider } from './components/ui/color-palette-context.tsx'

createRoot(document.getElementById('root')!).render(
//   <StrictMode>
<ColorPaletteProvider>
    <Provider>
        <App />
    </Provider>
</ColorPaletteProvider>
//    </StrictMode>,
)
